import { useState } from 'react';
import useThreeStore from '@modules/three/hooks/useThreeStore.ts';
import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import { Input } from '@/components/ui/input';
import { IconButton } from '@/components/ui/button';
import * as THREE from 'three';

export function ImportModel() {
  const [file, setFile] = useState<File | null>(null);
  const [isActive, setIsActive] = useState(false);
  const { rootState } = useThreeStore();

  async function importModel() {
    const mesh = await BaseThreeScene.loadMeshes([file!]);
    rootState.scene.children.forEach((child) => {
      rootState.scene.remove(child);
    });
    mesh[0].material = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
    });
    rootState.scene.add(mesh[0]);
    console.log('Model imported:', mesh[0]);
    setIsActive(false);
  }

  if (!isActive) {
    return <IconButton onClick={() => setIsActive(true)}>Import Model</IconButton>;
  }

  return (
    <>
      <div className={'bg-content p-4 text-white flex flex-col justify-center rounded-2xl'}>
        <h2 className="text-lg font-semibold mb-4">Import Model</h2>
        <Input
          type="file"
          accept=".stl,.obj,.glb,.ply"
          onChange={(e) => {
            if (e.target.files && e.target.files.length > 0) {
              setFile(e.target.files[0]);
            }
          }}
          className="mb-4"
        />
        {file && (
          <div>
            <p>Selected file: {file.name}</p>
            <IconButton
              onClick={() => {
                importModel();
              }}
            >
              Upload
            </IconButton>
          </div>
        )}
      </div>
    </>
  );
}
